<template>
  <div>
    <Panel :data="consult"/>
    <hr>
    <h3>Requisições</h3>
    <Requests v-if="consult && consult.id" :consult="consult"/>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import Requests from './Requests'

import { mapMutations } from 'vuex'
import Panel from '../Panel.vue'

export default {
  components: { Panel, Requests },
  computed: {
    consult() {
      return this.getModel
    },
  },
  created() {
    this.asyncTemplateShow(this.id, {
      after: ({model}) => this.setNameBreadcrumb(model.id)
    })
  },
  data: () => ({
    modelPathPrefix: 'admin/maestro',
    nameModel: 'Consult',
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
  },
  mixins: [ModelMapper],
  name: 'Show',
  props: {
    id: { required: false }
  }
}

</script>

<style scoped>

</style>